import React, { Component } from 'react'
import CurrencyFormat from 'react-currency-format'
import { connect } from 'react-redux'
import { UpdateIntField } from '../../engine/Rules'
import store from '../../engine/store'
import { Bloc, Conditionnal, InfoBulle } from '../ImportAll'
import './Bloc.css'

class BlocCredit extends Component {
    render() {
        /////////////////////////////////
        // définition du style du bloc //
        /////////////////////////////////
        let className = 'Bloc fade-in bloc-full'
        const style = {}
        style.display = 'table'
        //////////////////////////////////
        // définition de l'état du bloc //
        //////////////////////////////////
        let infobulle
        if (this.props.infobulle && this.props.infobulle !== undefined) {
            infobulle = (
                <div className="infoBulleContainer">
                    <InfoBulle text={this.props.infobulle} />
                </div>
            )
        }

        const varNameid = this.props.id
        const varNameType = 'credit_existants_type_' + this.props.id
        const varNameMens = 'credit_existants_mens_' + this.props.id
        const varNameduree = 'credit_existants_duree_' + this.props.id

        const removeCredit = () => {
            store.dispatch({
                type: 'SET_MULTI',
                value: { key: 'credit_existants_list', value: varNameid },
            })
        }

        let premadeContent = (
            <div className="credit">
                <div className="infoBulleContainer">
                    <img
                        src="svg/delete.svg"
                        alt="remove"
                        onClick={removeCredit}
                    />
                </div>
                <div className="label1">Type de crédit : </div>

                <div className="Container">
                    <Conditionnal linked_data_id={varNameType} isEmpty>
                        <Bloc
                            nbcolumn={2}
                            selectable
                            linked_data_id={varNameType}
                            linked_data_value="IMMO_RES_PRINCIPALE"
                            height={181}
                            gauche
                            imageTextStyle
                            logourl="png/cred_rp.png"
                            text1="Crédit immobilier"
                            text2="Résidence principale"
                        />
                        <Bloc
                            nbcolumn={2}
                            selectable
                            linked_data_id={varNameType}
                            linked_data_value="IMMO_LOCATIF"
                            height={181}
                            droit
                            imageTextStyle
                            logourl="png/cred_loc.png"
                            text1="Crédit immobilier"
                            text2="Locatif"
                        />
                        <Bloc
                            nbcolumn={2}
                            selectable
                            linked_data_id={varNameType}
                            linked_data_value="TRAVAUX"
                            height={181}
                            gauche
                            imageTextStyle
                            logourl="png/cred_travaux.png"
                            text1="crédit"
                            text2="Travaux"
                        />
                        <Bloc
                            nbcolumn={2}
                            selectable
                            linked_data_id={varNameType}
                            linked_data_value="AUTO"
                            height={181}
                            droit
                            imageTextStyle
                            logourl="png/cred_car.png"
                            text1="crédit"
                            text2="Automobile"
                        />
                        <Bloc
                            nbcolumn={2}
                            selectable
                            linked_data_id={varNameType}
                            linked_data_value="CONSO"
                            height={181}
                            gauche
                            imageTextStyle
                            logourl="png/cred_conso.png"
                            text1="crédit"
                            text2="Consommation"
                        />
                        <Bloc
                            nbcolumn={2}
                            selectable
                            linked_data_id={varNameType}
                            linked_data_value="TRESORERIE"
                            height={181}
                            droit
                            imageTextStyle
                            logourl="png/cred_treso.png"
                            text1="crédit"
                            text2="Trésorerie"
                        />
                        <Bloc
                            nbcolumn={2}
                            selectable
                            linked_data_id={varNameType}
                            linked_data_value="PRET_ETUDIANT"
                            height={181}
                            gauche
                            imageTextStyle
                            logourl="png/cred_stud.png"
                            text1="crédit"
                            text2="Prêt étudiant"
                        />
                    </Conditionnal>

                    <Conditionnal
                        linked_data_id={varNameType}
                        isEqualTo
                        targetDataValueCompare="IMMO_RES_PRINCIPALE"
                    >
                        <Bloc
                            forceSelected
                            nbcolumn={1}
                            selectable
                            linked_data_id={varNameType}
                            linked_data_value_empty
                            simpleWord
                            text1="Crédit immobilier Résidence principale"
                        />
                    </Conditionnal>
                    <Conditionnal
                        linked_data_id={varNameType}
                        isEqualTo
                        targetDataValueCompare="IMMO_LOCATIF"
                    >
                        <Bloc
                            forceSelected
                            nbcolumn={1}
                            selectable
                            linked_data_id={varNameType}
                            linked_data_value_empty
                            simpleWord
                            text1="Crédit immobilier Locatif"
                        />
                    </Conditionnal>
                    <Conditionnal
                        linked_data_id={varNameType}
                        isEqualTo
                        targetDataValueCompare="TRAVAUX"
                    >
                        <Bloc
                            forceSelected
                            nbcolumn={1}
                            selectable
                            linked_data_id={varNameType}
                            linked_data_value_empty
                            simpleWord
                            text1="Crédit Travaux"
                        />
                    </Conditionnal>
                    <Conditionnal
                        linked_data_id={varNameType}
                        isEqualTo
                        targetDataValueCompare="AUTO"
                    >
                        <Bloc
                            forceSelected
                            nbcolumn={1}
                            selectable
                            linked_data_id={varNameType}
                            linked_data_value_empty
                            simpleWord
                            text1="Crédit Automobile"
                        />
                    </Conditionnal>
                    <Conditionnal
                        linked_data_id={varNameType}
                        isEqualTo
                        targetDataValueCompare="CONSO"
                    >
                        <Bloc
                            forceSelected
                            nbcolumn={1}
                            selectable
                            linked_data_id={varNameType}
                            linked_data_value_empty
                            simpleWord
                            text1="Crédit Consommation"
                        />
                    </Conditionnal>
                    <Conditionnal
                        linked_data_id={varNameType}
                        isEqualTo
                        targetDataValueCompare="TRESORERIE"
                    >
                        <Bloc
                            forceSelected
                            nbcolumn={1}
                            selectable
                            linked_data_id={varNameType}
                            linked_data_value_empty
                            simpleWord
                            text1="Crédit Trésorerie"
                        />
                    </Conditionnal>
                    <Conditionnal
                        linked_data_id={varNameType}
                        isEqualTo
                        targetDataValueCompare="PRET_ETUDIANT"
                    >
                        <Bloc
                            forceSelected
                            nbcolumn={1}
                            selectable
                            linked_data_id={varNameType}
                            linked_data_value_empty
                            simpleWord
                            text1="Crédit Prêt étudiant"
                        />
                    </Conditionnal>
                </div>
                <Conditionnal linked_data_id={varNameType} isNotEmpty>
                    <div className="label2">Mensualité : </div>
                    <CurrencyFormat
                        value={this.props.cred_mens}
                        placeholder="Ex : 500 € / mois"
                        className="field bold-font"
                        thousandSeparator={' '}
                        decimalSeparator={','}
                        allowNegative={false}
                        type="tel"
                        format={'#####  € / mois'}
                        suffix=" € / mois"
                        onValueChange={(value) =>
                            UpdateIntField(varNameMens, value)
                        }
                    />

                    <div className="label3">Durée restante (en mois) : </div>
                    <CurrencyFormat
                        value={this.props.cred_duree}
                        placeholder="Ex : 60 mois"
                        className="field bold-font"
                        thousandSeparator={' '}
                        allowNegative={false}
                        decimalSeparator={','}
                        type="tel"
                        format={'###  mois'}
                        suffix=" mois"
                        onValueChange={(value) =>
                            UpdateIntField(varNameduree, value, 420)
                        }
                    />
                </Conditionnal>
            </div>
        )
        if (this.props.cred_type && this.props.cred_type !== undefined) {
            style.minHeight = '360px'
        } else {
            style.minHeight = '740px'
        }

        return (
            <div>
                <div className={className} style={style}>
                    {infobulle}
                    {premadeContent}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    // if multi field linked on credit feature
    if (ownProps.id) {
        const varNameType = 'credit_existants_type_' + ownProps.id
        const varNameMens = 'credit_existants_mens_' + ownProps.id
        const varNameduree = 'credit_existants_duree_' + ownProps.id
        return {
            cred_type: state.answer[varNameType],
            cred_mens: state.answer[varNameMens],
            cred_duree: state.answer[varNameduree],
        }
    }
    return {}
}

export default connect(mapStateToProps)(BlocCredit)
